module.exports = __webpack_public_path__ + "img/sample-performance.25a2dd60.png";